var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMain3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54 27C54 41.9117 41.9117 54 27 54C12.0883 54 0 41.9117 0 27C0 12.0883 12.0883 0 27 0C41.9117 0 54 12.0883 54 27Z",
    fill: "#111113"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.761 11H22.3503C20.5131 11.0021 19.0243 12.5248 19.0225 14.4038V39.5964C19.0243 41.4755 20.5131 42.998 22.3503 42.9999H32.761C34.5983 42.9981 36.087 41.4754 36.0891 39.5964V14.4038C36.0871 12.5248 34.5983 11.0022 32.761 11ZM34.6667 39.5964C34.6657 40.6724 33.8131 41.5444 32.761 41.5455H22.3503C21.2983 41.5444 20.4457 40.6724 20.4446 39.5964V14.4038C20.4457 13.3275 21.2983 12.4555 22.3503 12.4545H32.761C33.8131 12.4555 34.6657 13.3275 34.6667 14.4038V39.5964Z",
    fill: "#F75524"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.9327 13.9091H25.569C25.1674 13.9091 24.8417 14.2345 24.8417 14.6362C24.8417 15.0379 25.1674 15.3636 25.569 15.3636H29.9327C30.3343 15.3636 30.6598 15.0379 30.6598 14.6362C30.6598 14.2345 30.3343 13.9091 29.9327 13.9091ZM29.2053 38.6362C29.2053 39.4397 28.5542 40.0909 27.7509 40.0909C26.9473 40.0909 26.2961 39.4398 26.2961 38.6362C26.2961 37.833 26.9473 37.1818 27.7509 37.1818C28.5541 37.1818 29.2053 37.8329 29.2053 38.6362Z",
    fill: "#F75524"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMain3);
export default __webpack_public_path__ + "static/media/main3.fadfdea88776fadd6294e1b4de31cec9.svg";
export { ForwardRef as ReactComponent };